namespace Core.CarHire {

    export enum FuelPolicyType {
        FullFull = 0,
        EmptyEmpty = 1,
        FullEmpty = 2,
        HalfEmpty = 3,
        QuarterEmpty = 4,
        HalfHalf = 5,
        QuarterQuarter = 6,
        FreeTank = 7,
        FullEmptyRefund = 8,
        FullFullHybrid = 9,
        ChauFulFul = 10,
        ChaufFuelInc = 11,
        Unknown = 12
    }

    export enum FuelType {
        Unspecified = 0,
        Petrol = 1,
        Diesel = 2
    }

    export interface RentalInformation {
        Code :string;
        Information :string;
        Title :string;
    }

    export interface Id {
        CarHireCode :string;
        SupplierId :number;
    }

    export interface Quote {
        CarHireId : Id;
        Adults :number;
        BaggageQuantity :number;
        BaggageQuantitySmall :number;
        BalanceDueDays :number | null;
        Capacity :number;
        CarImageSmall :string;
        Children :number;
        Class :string|null;
        CompanyLogo :string;
        CompanyName :string;
        DealId :number;
        Deposit :number | null;
        DepositAmount :number;
        Description :string;
        DoorCount:number;
        DropOffLocation :string;
        DropOffLocationId  :string;
        ExampleModel :string;
        Exclusions :RentalInformation[];
        FuelPolicy :string;
        FuelPolicyDescription :string;
        FuelPolicyType :FuelPolicyType;
        FuelType :FuelType;
        Inclusions :RentalInformation[];
        Information :RentalInformation[];
        IsAirConditioned :boolean;
        IsAutomatic :boolean;
        IsBasicOption :boolean;
        Mileage :number;
        PickUpLocation :string;
        PickUpLocationId :string;
        Price :number;
        PricePayableLocally :number;
        PricePayableNow :number;
        SpecialOfferText :string;
        SupplierId :number;
        SupplierName :string;
        SupplierRateCode :string;
        TheftWaiver :boolean;
        ThirdPartyLiabilityProtection :boolean;
        VendorCode :string;
        VendorImageUrl :string;
        VendorLocationCode :string;
        VendorName :string;
        VendorOperatorCode :string;
        VendorOperatorImageUrl :string;
        VendorOperatorName :string;
    }

    export enum SortOrder {
        None = 0,
        Price = 1,
        Recommended = 2
    }

}
